import NavBar from './NavBar'

import StatusBar from './StatusBar'

import MainContent from './MainContent'

import FooterBar from './FooterBar'

export { NavBar, StatusBar, MainContent, FooterBar }



// WEBPACK FOOTER //
// ./src/components/layout/index.js